// import React from "react";
import { useState } from "react";
import productsData from "../data/products";
import ProductModal from "../components/ProductCard";


function AllProducts() {
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedProduct, setSelectedProduct] = useState(null);

    const categories = [
        "All",
        "Insecticide",
        "Fungicide",
        "Herbicide",
        "Plant Growth Regulator",
        "Fertilizer",
        "NPK Fertilizer",
        "Others"
    ];

    const filteredProducts =
        selectedCategory === "All"
            ? productsData
            : productsData.filter(p => p.category === selectedCategory);

    return (
        <>
            {/* CATEGORY FILTER */}
            <div className="container my-4 text-center">
                {categories.map(cat => (
                    <button
                        key={cat}
                        className={`btn btn-outline-success m-1 ${selectedCategory === cat ? "active" : ""
                            }`}
                        onClick={() => setSelectedCategory(cat)}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            {/* PRODUCTS GRID */}
            <div className="container">
                <div className="row">
                    {filteredProducts.map(product => (
                        <div className="col-lg-3 col-md-4 col-sm-6 mb-4 Product-col" key={product.id}>
                            <div
                                className="product-card"
                                onClick={() => setSelectedProduct(product)}
                            >
                                <img src={product.image} alt={product.name} />
                                <div className="product-overlay">
                                    <h6>{product.name}</h6>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* PRODUCT DETAILS MODAL */}
            {selectedProduct && (
                <ProductModal
                    product={selectedProduct}
                    close={() => setSelectedProduct(null)}
                />
            )}
        </>
    );
}
export default AllProducts;
